
const DownArrowIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="0.798844" height="8.48531" rx="0.399422" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 14.0156 5.5)" fill="#0C0C0C"/>
<rect width="0.795775" height="8.48531" rx="0.397888" transform="matrix(-0.707107 0.707107 0.707107 0.707107 2.57825 4.9375)" fill="#0C0C0C"/>
</svg>


  )
}

export default DownArrowIcon